import {
    postRouteDeliveryPointLoading,
    postRouteDeliveryPointRequest,
    postRouteDeliveryPointSuccess,
    postRouteDeliveryPointReject,
    postRouteDeliveryPointReset
} from "../../actions/route/postDeliveryPoint";

export const postRouteDeliveryPoint = (formData) => async (dispatch, getState) => {
    dispatch(postRouteDeliveryPointLoading());
    try {
        const { data } = await postRouteDeliveryPointRequest(formData, getState);
        dispatch(postRouteDeliveryPointSuccess(data))
    } catch (error) {
        dispatch(postRouteDeliveryPointReject(error))
    } finally {
        setTimeout(() => { dispatch(postRouteDeliveryPointReset()) }, 3000);
    }
    return Promise.resolve();
};